import {
    useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import useLabel from 'app/hooks/useLabel'
import useTableStyles from 'app/tss/table.styles'

import requestConfig from 'app/requests/LongTermLease/LongTermLease.requests'
import {
    RequiredContainersChangeType,
} from '../../longTermLease.types'
import getColumns from './requiredContainersChange.columns'

const RequiredContainersChange = ({
    longTermLeaseId,
}: {
    longTermLeaseId: number,
}) => {
    const loadConfig = useMemo(() => {
        const urlConfig = requestConfig.requiredContainersChange(longTermLeaseId)

        return {
            ...urlConfig,
            customUrl: urlConfig.url,
            name: 'RequiredContainersChange',
        }
    }, [longTermLeaseId])
    const {
        classes: tableClasses,
    } = useTableStyles()
    const l = useLabel()
    const load: (params: any) => Promise<{
        items: RequiredContainersChangeType[],
        matches: number,
    }> = useLoadDtoForSkyNetTable(
        loadConfig,
    )
    const columns = getColumns(l)

    return (
        <RichTable
            configName="RequiredContainersChangeTable"
            name="RequiredContainersChange"
            columns={columns}
            load={load}
            className={tableClasses.tableContent}
            classNames={{
                contentWrapper: tableClasses.tableContentWrapper,
            }}
        />
    )
}

export default RequiredContainersChange
